import React, { Fragment } from 'react';
import { getAnchorId } from '@/helpers/utils';
import Partner from './Partner';
import { ChefProfile } from '../interface';
import Divider from '../Divider';

interface ChefProfilesProps {
  partners: ChefProfile[];
  sectionHeader: string;
}

const ChefProfiles: React.FC<ChefProfilesProps> = ({
  partners,
  sectionHeader,
}) => (
  <>
    <h2 className="margin-3-b color-text-emphasis tw-col-span-6 tw-col-start-2 tw-text-2xl">
      {sectionHeader}
    </h2>
    {partners.map((partner, idx) => {
      const anchorId = getAnchorId({
        type: 'chef',
        name: partner.name,
        title: undefined,
        idx,
        section: sectionHeader,
      });
      return (
        <Fragment key={partner.name}>
          <Partner partner={partner} anchorId={anchorId} />
          <Divider />
        </Fragment>
      );
    })}
  </>
);

export default ChefProfiles;
